<template>
  <RecentVisitListLayout
    title="Исследования и анализы"
    :buttons="buttons"
    :sections="data?.length ? 3 : 1"
    :class="{'no-list-data': !data?.length}"
  >
    <template v-if="data?.length">
      <labs-card v-for="lab in data" :key="lab" :item="lab" @go="openCard($event)" manual-go></labs-card>
    </template>
    <h4 v-else class="h2 adaptive color-dark w-100">
      Не найдены исследования и анализы
    </h4>
  </RecentVisitListLayout>
</template>

<script>
import RecentVisitListLayout from "@/layouts/RecentVisitListLayout.vue";
import LabsCard from "@/components/cards/LabsCard";
import { computed, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { useUserLabsStore } from "@/store/userLabs";
export default {
  name: "UserUpcomingLabs",
  components: {
    LabsCard,
    RecentVisitListLayout,
  },
  setup() {
    const router = useRouter();
    const userLabStore = useUserLabsStore();
    onBeforeMount(() => {
      userLabStore.loadAll({ end: 3 });
    });

    return {
      data: computed(() => userLabStore.data),

      buttons: [
        {
          title: "Все исследования и анализы",
          onClick: () => {
            router.push("/labs");
          },
        },
      ],
      openCard: (id) => {
        // router.push({
        //   name: `labs-card`,
        //   params: { id: `${id}` },
        // });
        router.push("/labs");
      },
    };
  },
};
</script>

<style scoped></style>
